module.exports = __webpack_public_path__ + "img/62.7fc17655.jpg";